import React, { Component } from 'react';
import moment from 'moment';
import Accordion from 'travco-accordion';
import PriceBreakdown from './price-breakdown';
import _isEqual from 'lodash/isEqual';
import * as ROOMTYPE from '../../utils/enums';

export default class RoomPrice extends Component {

    generatePrices(rate, rooms, roomsRequired){
        let singleCount = 0;
        let doubleCount = 0;

        rooms.forEach((r) => {
            if (['Single','Double for Single Use','Twin for Single Use'].includes(r.name)) singleCount++;
            else if (['Twin','Double'].includes(r.name)) doubleCount++;
        });

        const onlySingle = singleCount < 2;
        const onlyDouble = doubleCount < 2;

        return rooms.map((room, index) => {
            let quantity = 0;
            switch (true) {
                case room.name.toLowerCase() === 'twin':
                    quantity = roomsRequired['double'];
                    break;
                case room.name.toLowerCase() === 'double for single use' || room.name.toLowerCase() === 'twin for single use':
                    quantity = roomsRequired['single'];
                    break;
                default:
                    quantity = roomsRequired[room.name.toLowerCase()];
                    break;
            }

            const adultTotal = (['Double for Single Use','Twin for Single Use'].includes(room.name)) ? 
                room.adultRate * roomsRequired.single : room.adultRate * (ROOMTYPE[room.name.toUpperCase()] * roomsRequired[room.name.toLowerCase()]);

            return (
                <div
                    key={'generated-room-label' + index}
                    label={
                        <div ref={'roomPrice-' + room.name + index} isOpen style={{ display: 'inline-block' }}>
                            <div
                                className={`header-cell ${['Twin','Double for Single Use','Twin for Single Use'].includes(room.name)
                                    ? 'group-option' : ''} room`}>
                                <label className="container">
                                    {['Twin','Double'].includes(room.name) &&
                                    !onlyDouble && (
                                        <div>
                                            <input
                                                type="radio"
                                                value={room.name}
                                                name={`double-twin-${rate.id}`}
                                                checked={this.props.selectedRooms.has(room.name)}
                                                onClick={this.props.onRoomTypeSelected.bind(this)}
                                            />
                                            <span className="checkMark" />
                                        </div>
                                    )}
                                    {['Single','Double for Single Use','Twin for Single Use'].includes(room.name) &&
                                    !onlySingle && (
                                        <div>
                                            <input
                                                type="radio"
                                                value={room.name}
                                                name={`singles-opt-${rate.id}`}
                                                checked={this.props.selectedRooms.has(room.name)}
                                                onClick={this.props.onRoomTypeSelected.bind(this)}
                                            />
                                            <span className="checkMark" />
                                        </div>
                                    )}
                                    {room.name}
                                </label>
                            </div>
                            <div
                                className={`header-cell ${['Twin','Double for Single Use','Twin for Single Use'].includes(room.name)
                                    ? 'group-option' : ''} quantity`}>
                                <div className="header-cell-data">{quantity}</div>
                            </div>
                            <div
                                className={`header-cell ${['Twin','Double for Single Use','Twin for Single Use'].includes(room.name)
                                    ? 'group-option' : ''} date`}>
                                <div className="header-cell-data">
                                    {typeof room.sellingRates === 'object' && room.sellingRates.length > 0 ? (
                                        moment(room.sellingRates[0].date).format('DD / MMM / YYYY')
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                            <div
                                className={`header-cell ${['Twin','Double for Single Use','Twin for Single Use'].includes(room.name)
                                    ? 'group-option' : ''} nights`}>
                                <div className="header-cell-data">{room.sellingRates.length}</div>
                            </div>
                            <div
                                className={`header-cell ${['Twin','Double for Single Use','Twin for Single Use'].includes(room.name)
                                    ? 'group-option' : ''} total`}>
                                <div className="header-cell-data">
                                    {new Intl.NumberFormat('en-GB', {
                                        style: 'currency',
                                        currency: rate.currencyName,
                                        currencyDisplay: 'code'
                                    }).format(adultTotal + room.childRate * roomsRequired['extraBeds'])}
                                </div>
                            </div>
                        </div>
                    }>
                    <PriceBreakdown
                        sellPrices={room.sellingRates}
                        currency={rate.currencyName}
                        showChild={roomsRequired.extraBeds > 0 && ['Twin','Double'].includes(room.name)}
                    />
                </div>
            );
        });
    }

    render() {
        const { rate, rooms, roomsRequired } = this.props;

        return (
            <div className="booking-details">
                <div className="header-title">
                    <span className="header-cell-caption room">&nbsp;</span>
                    <span className="header-cell-caption quantity">Quantity</span>
                    <span className="header-cell-caption date">From</span>
                    <span className="header-cell-caption nights">Nights</span>
                    <span className="header-cell-caption total">Room Total</span>
                    <span className="header-cell-caption action">&nbsp;</span>
                </div>
                <Accordion allowMultipleOpen>{this.generatePrices(rate, rooms, roomsRequired)}</Accordion>
            </div>
        );
    }
}
